import { AppState } from 'src/store/app/types';

const hidePopupReducer = (state: AppState) => {
  state.activePopup = undefined;
};

export default hidePopupReducer;
